module.exports = __webpack_public_path__ + "50145685042b4df07a1fd19957275b81.ttf";